import DemoCard from '../DemoCard'
import { DemoSectionProps } from '../types'

const MedicalWaste = ({ triggerDemo }: DemoSectionProps ) => {
  const demos = [
    {
      demo: 'practiceMedicalWasteReset',
      isReset: true,
      buttonText: 'Reset All Medical Waste Data',
      features: [
        'Remove All Medical Waste Data'
      ]
    },
    {
      demo: 'practiceMedicalWasteOhHand',
      isReset: false,
      buttonText: 'Prepare One Sharps Container On Hand',
      features: [
        'One sharps container with status sent'
      ]
    },
    {
      demo: 'practiceMedicalWasteSameStatus',
      isReset: false,
      buttonText: 'Prepare Many Sharps with Same Status',
      features: [
        '5 sharps containers with status "on-hand"'
      ]
    },
    {
      demo: 'practiceMedicalWasteMixedStatus',
      isReset: false,
      buttonText: 'Prepare Many Sharps with Mixed Status',
      features: [
        '2 sharps containers with status "on-hand"',
        '2 sharps containers with status "sent"',
        '2 sharps containers with status "destroyed"',
        '2 sharps containers with status "heavy"'
      ]
    },
    {
      demo: 'practiceMedicalWasteAllSharps',
      isReset: false,
      buttonText: 'Prepare All Sharps with Mixed Status',
      features: [
        'All sharps containers with status "on-hand"'
      ]
    },
    {
      demo: 'practiceMedicalWasteDestroyed',
      isReset: false,
      buttonText: 'Prepare Sharps in the Past, None Available, One Destroyed',
      features: [
        '1 sharps container status "destroyed", none availible'
      ]

    }
  ]

  return (
    <DemoCard headerText='Medical Waste (sharps)' demos={demos} triggerDemo={triggerDemo} />
  )
}

export default MedicalWaste